export class PaginationParams { //' PagingParams
    // constructor() {
    //     this.pageNumber = 1;
    //     this.pageSize = 10; // 2; for test
    // }

    constructor(pagNumber = 1, pagSize = 2) {
        this.pageNumber = pagNumber;
        this.pageSize = pagSize; // 2; for test
    }

    pageNumber: number;
    pageSize: number;
}